import { z } from 'zod';

export const formSchema = z.object({
  ma_ngan_hang: z.string().nonempty('Mã ngân hàng là bắt buộc'),
  ten_ngan_hang: z.string().nonempty('Tên ngân hàng là bắt buộc'),
  ten_ngan_hang2: z.string().optional().nullable(),
  ma_so: z.string().optional().nullable(),
  status: z.coerce.number().optional()
});

export type FormValues = z.infer<typeof formSchema>;

export const initialValues: FormValues = {
  ma_ngan_hang: '',
  ten_ngan_hang: '',
  ten_ngan_hang2: '',
  ma_so: '',
  status: 1
};
